import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';

Exporting(Highcharts);
ExportData(Highcharts);

class ObservacioExportacioGrafica extends Component {

    /**
     * Creacio del objecte HighChart. La configuració de la fràfica be donada pel component
     * pare com ha propietat.
     */
    componentDidMount() {
        const { options } = this.props;

        this.crearGrafica(options);
    }

    /**
     * Quan rep una nova configuració la gràfica se ha de tornar a pintar. Dintre de la nova
     * configuració també hi hauran les dades.
     * @param {object} nextProps
     */
    componentWillUpdate(nextProps) {
        const { options } = nextProps;

        //Se destruye porque el metodo this.chart.update(options), no actualiza todas propietades del options de la grafica.
        //Por ejemplo el envet.render() se quedaba si se habia creado previamente, aunque la nueva configuración no lo tenga.
        this.chart.destroy();

        this.crearGrafica(options);
    }

    componentWillUnmount() {
        this.chart.destroy();
    }

    crearGrafica(options) {
        this.chart = new Highcharts.Chart(this.chartContainer, options);
    }

    render() {
        if (!this.props.options) {
            return <div>Sense dades</div>;
        }

        return (
            <div className='observacio-exportacio-grafica'
                ref={ref => this.chartContainer = ref} >
            </div>
        );
    }
}

ObservacioExportacioGrafica.propTypes = {
    options: PropTypes.object
};

export default ObservacioExportacioGrafica;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioExportacioGrafica.js